import {matchMediaXlDown} from "./mediaQuery";
import {parents} from "./utilities";
import {main} from "@popperjs/core";

/**
 * Main Nav handler (desktop & mobile)
 * @type {NodeListOf<Element>}
 */
const mainNavHandler = (mainNav, mainNavLinks) => {
    if (!mainNav || !mainNavLinks) return;

    // Except search trigger
    mainNavLinks = [...mainNavLinks].filter((mainNavLink) => !mainNavLink.classList.contains('nav-link--search-trigger'));

    const getActive = (target) => {
        if (!target) return;
        return target.classList.contains('active');
    }

    const getDropdown = (target) => {
        if (!target) return;
        return target.parentNode.querySelector('.main-nav-dropdown');
    }

    const openDropdown = (target) => {
        if (!target) return;
        closeDropdown();
        target.classList.add('active');
        getDropdown(target).classList.add('show');
        if (!document.body.classList.contains('main-nav-dropdown-shown')) {
            document.body.classList.add('main-nav-dropdown-shown');
        }
    }

    const closeDropdown = () => {
        document.body.classList.remove('main-nav-dropdown-shown');
        mainNav.querySelector('.nav-link--main.active')?.classList.remove('active');
        mainNav.querySelector('.main-nav-dropdown.show')?.classList.remove('show');
    }

    const handleDropdown = (target) => {
        if (!target) return;
        if (!target.classList.contains('has-children')) {
            closeDropdown();
        } else {
            // const mainNavLinkActive = mainNav.querySelector('.nav-link--main.active');
            const isActive = getActive(target);
            isActive ? closeDropdown() : openDropdown(target);
        }
    }

    if (!matchMediaXlDown.matches) {
        mainNavLinks.forEach(mainNavLink => {
            /**
             * Handle mouseenter for desktop
             */
            mainNavLink.addEventListener('mouseenter', (e) => {
                const target = e.target;
                handleDropdown(target);
            });
        });

        document.querySelector('.main-header')?.addEventListener('mouseleave', closeDropdown);
    }

    /**
     * Mobile Navbar Toggler
     * @type {Element}
     */
    const mobileNavbarToggler = document.getElementById('mobile-navbar-toggler');
    if (mobileNavbarToggler) {
        mobileNavbarToggler.addEventListener('click', (e) => {
            e.preventDefault();
            const ariaExpanded = e.currentTarget.getAttribute('aria-expanded');

            if (ariaExpanded === "false") {
                e.currentTarget.setAttribute('aria-expanded', 'true');
            } else {
                e.currentTarget.setAttribute('aria-expanded', 'false');
                closeDropdown();
            }

            mainNav.classList.toggle('show');
            document.body.classList.toggle('main-nav-offcanvas-shown');

            const navbarNav = mainNav.parentNode.parentNode;
            if (mobileNavbarToggler.getAttribute('aria-expanded') === 'true') {
                navbarNav?.classList.remove('navbar-dark');
            } else {
                const theme = navbarNav.dataset.theme;
                navbarNav?.classList.add(theme);
            }
        });
    }

    /**
     * Handle click mobile menu voices
     */
    if (matchMediaXlDown.matches) {
        mainNav.addEventListener('click', (e) => {
            if (e.target.closest('.nav-link--main')) {
                // e.preventDefault();
                const isActive = getActive(e.target);
                isActive ? closeDropdown() : handleDropdown(e.target);
            }
        });
    }

    /**
     * Handle search trigger
     */
    const openSearchDropdown = (dropdown) => {
        if (!dropdown) return;

        dropdown?.classList.toggle('show');
        if (document.body.classList.contains('main-nav-offcanvas-shown')) mobileNavbarToggler?.click();

        dropdown.querySelector('.search-input')?.focus();
    }

    document.body.addEventListener('click', (e) => {
        if (e.target.closest('.nav-link--search-trigger')) {
            e.preventDefault();

            const expanded = e.target.getAttribute('aria-expanded') === 'true';
            e.target.setAttribute('aria-expanded', !expanded);

            const searchDropdown = e.target.nextElementSibling;
            openSearchDropdown(searchDropdown);
        }

        if (e.target.closest('.btn-search-close')) {
            e.preventDefault();

            const searchDropdown = e.target.parentNode.parentNode;
            openSearchDropdown(searchDropdown);
        }
    });
}

export default mainNavHandler;
